import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { ButtonModule } from '@sb/library/button';
import { CardModule } from '@sb/library/card';
import { IconModule } from '@sb/library/icon';
import { UtilityModule } from '@sb/library/utility';
import { ReviewCardComponent } from './review-card.component';
import { LocalizationModule } from '@sb/library/localization';
import { FormFieldModule } from '@sb/library/form-field';
import { ExpandableTextModule } from '@sb/library/expandable-text';
import { StarRatingModule } from '@sb/library/star-rating';
import { BaseModule } from '@sb/library/base';

@NgModule({
    declarations: [ReviewCardComponent],
    imports: [BaseModule, CommonModule, IconModule, ButtonModule, CardModule, MatDividerModule, UtilityModule, LocalizationModule, FormFieldModule, ExpandableTextModule, StarRatingModule],
    exports: [ReviewCardComponent],
})
export class ReviewCardModule {}
